import React, { useEffect } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { Button } from '@mui/material';
import { useNotification } from '../../contexts/NotificationContext';
import { useInventoryForm } from './shared/hooks/useInventoryForm';
import { useInventory } from './shared/services/useInventoryService';
import InventoryForm from './shared/sections/InventoryForm';
import FormPageLayout from '../../components/FormPageLayout';

const InventoryPage = () => {
  const { item_id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { showNotification } = useNotification();

  const { isEdit, loading, existingData, submit } = useInventory(item_id);
  const { formData, errors, setInitialData, handleChange, handleBlur, validate } = useInventoryForm();

  useEffect(() => { if (existingData) setInitialData(existingData); }, [existingData]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    try {
      await submit({ ...formData, hospital_id: 1 });
      showNotification('success', isEdit ? `Item "${formData.product_name}" updated!` : `Item "${formData.product_name}" added to inventory!`);
      
      const returnPage = location.state?.page || 0;
      const returnMenu = location.state?.activeMenu || 'Inventory';
      
      setTimeout(() => {
        navigate(`/home?page=${returnPage}`, { 
          state: { activeMenu: returnMenu } 
        });
      }, 1000);
    } catch (error) {
      showNotification('error', error.response?.data?.error || 'Failed to save inventory item.');
    }
  };

  return (
    <FormPageLayout 
      title={isEdit ? 'EDIT INVENTORY ITEM' : 'INVENTORY MANAGEMENT'} 
      backTo={{ 
        path: `/home?page=${location.state?.page || 0}`, 
        state: { activeMenu: location.state?.activeMenu || 'Inventory' } 
      }} 
      loading={loading}
    >
      <form onSubmit={handleSubmit}>
        <InventoryForm formData={formData} errors={errors} handleChange={handleChange} handleBlur={handleBlur} />
        <Button type="submit" variant="contained" color="primary" fullWidth sx={{ mt: 2 }}>{isEdit ? 'Update Item' : 'Add Item'}</Button>
      </form>
    </FormPageLayout>
  );
};

export default InventoryPage;
